import { render } from "./MenuAccount.vue?vue&type=template&id=50a3eabe&scoped=true&ts=true"
import script from "./MenuAccount.vue?vue&type=script&lang=ts"
export * from "./MenuAccount.vue?vue&type=script&lang=ts"

import "./MenuAccount.vue?vue&type=style&index=0&id=50a3eabe&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a3eabe"]])

export default __exports__